import React from "react";
import { Icon, IconName } from "@silversea-ssc/ui-components-react";

interface PackageIconProps {
  icon: string;
  className?: string;
}

const packageIconMap: Record<string, IconName> = {
  Services: "services",
  Flight: "free-flight",
  "Reduced Fares": "reduced-fares-in-business-class",
  Hotel: "free-hotel",
  Quito: "quito-by-night",
  "Private Flight": "private-flight-in-business-class",
  Shorex: "shore-excursions",
  "Food & Beverage": "food-beverage",
  Pack: "pack",
  "Single fares": "special-price",
  "Free transfers": "free-transfers",
  "Venetian Society": "venetian-society-saving",
  "Early Booking Bonus": "early-booking-bonus",
  "All Inclusive Offer": "all-inclusive-offer",
  "Door to Door": "door-to-door",
  "P2P Prepaid": "p2p-prepaid-promo",
  "Suite Upgrade": "suite-upgrade-promo",
  Clock: "clock"
};
const packageIconToIconName = (icon: string): IconName => {
  return packageIconMap[icon];
};

const PackageIcon: React.FC<React.PropsWithChildren<PackageIconProps>> = ({
  icon,
  className = undefined
}) => (
  <div className={className}>
    <Icon name={packageIconToIconName(icon)} size="2.5x" padding="large" />
  </div>
);

export default PackageIcon;
